import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21427040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-number" }
const _hoisted_2 = { class: "summary-card" }
const _hoisted_3 = { class: "summary-head" }
const _hoisted_4 = { class: "summary-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-title" }, "已添加亲情号", -1))
const _hoisted_6 = { class: "count" }
const _hoisted_7 = { class: "current" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, "/", -1))
const _hoisted_9 = { class: "progress-track" }
const _hoisted_10 = { class: "list-card" }
const _hoisted_11 = { class: "family-info" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = {
  key: 0,
  class: "phone"
}
const _hoisted_14 = { class: "status-row" }
const _hoisted_15 = {
  key: 1,
  class: "remark"
}
const _hoisted_16 = {
  key: 0,
  class: "empty"
}
const _hoisted_17 = { class: "tips-card" }
const _hoisted_18 = { class: "tips-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "使用说明", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "手表可免费拨打亲情号，消耗套餐语音时长", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "白名单外号码无法呼入手表，防止骚扰", -1))
const _hoisted_22 = { class: "popup-header" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "添加亲情号", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "手机号码", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "备注名称（选填）", -1))
const _hoisted_26 = { class: "popup-actions" }
const _hoisted_27 = { class: "popup-header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "确认亲情号", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "手机号码", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "短信验证码", -1))
const _hoisted_31 = { class: "popup-actions" }

import { computed, onMounted, reactive, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { showDialog, showToast } from 'vant'
  import { isFamilyNumberAdditionAllowed } from '@/utils/familyNumberAccess'
  import {
    getWifiCustomizationCardFamilyNumber,
    postWifiCustomizationCardFamilyNumberAdd,
    postWifiCustomizationCardFamilyNumberConfirm
  } from '@/api'

  interface FamilyItem {
    mobile: string
    customName?: string
    remarks: string
    status: number
    statusDesc: string
  }

  const maxCount = 10
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyNumber',
  setup(__props) {

  const route = useRoute()
  const phoneRule = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  const checkCodeRule = /^[A-Za-z0-9]{6}$/
  const addVisible = ref(false)
  const confirmVisible = ref(false)
  const confirmLoading = ref(false)
  const addPopupStyle = {
    width: 'calc(100% - 32px)',
    maxWidth: '360px',
    overflow: 'hidden'
  }
  const familyList = ref<FamilyItem[]>([])
  const form = reactive({
    phone: '',
    customName: ''
  })
  const confirmForm = reactive({
    mobile: '',
    checkCode: ''
  })

  const isFull = computed(() => familyList.value.length >= maxCount)
  const canAddFamilyNumber = computed(() => {
    return isFamilyNumberAdditionAllowed(route.query.hasPackage)
  })
  const progressPercent = computed(() => {
    return Math.min(familyList.value.length / maxCount * 100, 100)
  })

  function avatarClass(index: number) {
    const classList = ['blue', 'green', 'orange', 'purple', 'cyan']
    return classList[index % classList.length]
  }

  function avatarText(phone: string) {
    return phone ? phone.slice(-1) : '亲'
  }

  function maskPhone(phone: string) {
    return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
  }

  function statusClass(status: number) {
    if (status === 1 || status === 10) return 'success'
    if (status === 3 || status === 5 || status === 6 || status === 7) return 'warning'
    if (status === 4 || status === 8 || status === 9) return 'danger'
    return 'default'
  }

  function resetForm() {
    form.phone = ''
    form.customName = ''
  }

  function openAddPopup() {
    if (isFull.value) {
      showToast(`亲情号数量上限为${maxCount}个`)
      return
    }
    addVisible.value = true
  }

  function closeAddPopup() {
    addVisible.value = false
    resetForm()
  }

  function openConfirmPopup(item: FamilyItem) {
    confirmForm.mobile = item.mobile
    confirmForm.checkCode = ''
    confirmVisible.value = true
  }

  function closeConfirmPopup() {
    if (confirmLoading.value) return
    confirmVisible.value = false
    confirmForm.mobile = ''
    confirmForm.checkCode = ''
  }

  function submitAdd() {
    if (isFull.value) {
      showToast(`亲情号数量上限为${maxCount}个`)
      return
    }
    showDialog({
      title: '确认添加亲情号？',
      message: '亲情号只能新增，删除需要联系客服，请确认信息无误后继续。',
      showCancelButton: true,
      confirmButtonText: '确认添加',
      cancelButtonText: '取消'
    }).then(() => {
      postWifiCustomizationCardFamilyNumberAdd({
        iccid: route.params.iccid,
        mobile: form.phone,
        customName: form.customName
      }).then((res: any) => {
        if (res.code === 200) {
          closeAddPopup()
          showToast(res.result?.statusDesc || '添加成功')
          getFamilyList()
        } else {
          showToast({ message: res.message, forbidClick: true })
        }
      })
    })
  }

  function submitConfirm() {
    if (confirmLoading.value) return
    confirmLoading.value = true
    postWifiCustomizationCardFamilyNumberConfirm({
      iccid: route.params.iccid,
      mobile: confirmForm.mobile,
      checkCode: confirmForm.checkCode
    }).then((res: any) => {
      if (res?.code === 200 && res.result === true) {
        confirmLoading.value = false
        closeConfirmPopup()
        showToast('确认成功')
        getFamilyList()
      } else {
        showToast({ message: res?.message || '确认亲情号失败', forbidClick: true })
      }
    }).catch(() => {
      showToast({ message: '确认亲情号失败，请稍后重试', forbidClick: true })
    }).finally(() => {
      confirmLoading.value = false
    })
  }

  function getFamilyList() {
    getWifiCustomizationCardFamilyNumber({ iccid: route.params.iccid })
      .then((res: any) => {
        if (res.code === 200) {
          familyList.value = res.result || []
        } else {
          showToast({ message: res.message, forbidClick: true })
        }
      })
  }

  onMounted(() => {
    getFamilyList()
  })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(familyList.value.length), 1),
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(maxCount))
          ])
        ]),
        (canAddFamilyNumber.value)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 0,
              size: "small",
              class: "summary-add-btn",
              disabled: isFull.value,
              onClick: openAddPopup
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, { name: "plus" }),
                _createTextVNode(" 添加 ")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "progress-line",
          style: _normalizeStyle({ width: `${progressPercent.value}%` })
        }, null, 4)
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(familyList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "family-item",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["avatar", avatarClass(index)])
          }, _toDisplayString(avatarText(item.mobile)), 3),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.customName || maskPhone(item.mobile)), 1),
            (item.customName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(maskPhone(item.mobile)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(["status-tag", statusClass(item.status)])
              }, _toDisplayString(item.statusDesc || '--'), 3)
            ]),
            (item.remarks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.remarks), 1))
              : _createCommentVNode("", true)
          ]),
          (item.status === 3)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                size: "small",
                class: "confirm-entry-btn",
                onClick: ($event: any) => (openConfirmPopup(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 确认 ")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (familyList.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无亲情号"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_van_icon, { name: "info-o" }),
        _hoisted_19
      ]),
      _createElementVNode("ul", { class: "tips-list" }, [
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("li", null, "亲情号数量上限为" + _toDisplayString(maxCount) + "个")
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: addVisible.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((addVisible).value = $event)),
      round: "",
      "close-on-click-overlay": false,
      class: "add-popup",
      style: addPopupStyle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_van_icon, {
            name: "cross",
            class: "close-icon",
            onClick: closeAddPopup
          })
        ]),
        _createVNode(_component_van_form, { onSubmit: submitAdd }, {
          default: _withCtx(() => [
            _hoisted_24,
            _createVNode(_component_van_field, {
              modelValue: form.phone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.phone) = $event)),
              type: "tel",
              placeholder: "请输入11位手机号码",
              maxlength: "11",
              rules: [
            { required: true, message: '请输入手机号码' },
            { pattern: phoneRule, message: '请输入正确的手机号码' }
          ]
            }, null, 8, ["modelValue", "rules"]),
            _hoisted_25,
            _createVNode(_component_van_field, {
              modelValue: form.customName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.customName) = $event)),
              type: "text",
              placeholder: "请输入亲情号名称",
              maxlength: "64"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_van_button, {
                block: "",
                class: "cancel-btn",
                "native-type": "button",
                onClick: closeAddPopup
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                block: "",
                class: "save-btn",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: confirmVisible.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((confirmVisible).value = $event)),
      round: "",
      "close-on-click-overlay": false,
      class: "confirm-popup",
      style: addPopupStyle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_van_icon, {
            name: "cross",
            class: _normalizeClass(["close-icon", { disabled: confirmLoading.value }]),
            onClick: closeConfirmPopup
          }, null, 8, ["class"])
        ]),
        _createVNode(_component_van_form, { onSubmit: submitConfirm }, {
          default: _withCtx(() => [
            _hoisted_29,
            _createVNode(_component_van_field, {
              "model-value": maskPhone(confirmForm.mobile),
              readonly: ""
            }, null, 8, ["model-value"]),
            _hoisted_30,
            _createVNode(_component_van_field, {
              modelValue: confirmForm.checkCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmForm.checkCode) = $event)),
              modelModifiers: { trim: true },
              type: "text",
              placeholder: "请输入6位短信验证码",
              maxlength: "6",
              autocomplete: "one-time-code",
              rules: [
            { required: true, message: '请输入短信验证码' },
            { pattern: checkCodeRule, message: '请输入6位字母或数字验证码' }
          ]
            }, null, 8, ["modelValue", "rules"]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_van_button, {
                block: "",
                class: "cancel-btn",
                "native-type": "button",
                disabled: confirmLoading.value,
                onClick: closeConfirmPopup
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 取消 ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_van_button, {
                block: "",
                class: "save-btn",
                "native-type": "submit",
                loading: confirmLoading.value,
                "loading-text": "确认中..."
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 确认 ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})